import { EventId } from "./CMDTypes";

export class InvalidEventIdFormatError extends Error {
  constructor(eventId: EventId) {
    super(`Event ID "${eventId}" is an invalid format.`);
  }
}
